{
  "TEXT_ALL_SELECTED": "All Selected",
  "TEXT_CANCEL": "Cancel",
  "TEXT_CLOSE": "Close",
  "TEXT_CLEAR_ALL_FILTERS": "Clear all Filters",
  "TEXT_CLEAR_ALL_GROUPING": "Clear all Grouping",
  "TEXT_CLEAR_ALL_SORTING": "Clear all Sorting",
  "TEXT_CLEAR_PINNING": "Unfreeze Columns/Rows",
  "TEXT_COLLAPSE_ALL_GROUPS": "Collapse all Groups",
  "TEXT_COLUMNS": "Columns",
  "TEXT_COLUMN_RESIZE_BY_CONTENT": "Resize by Content",
  "TEXT_COMMANDS": "Commands",
  "TEXT_CONTAINS": "Contains",
  "TEXT_COPY": "Copy",
  "TEXT_EMPTY_DATA_WARNING_MESSAGE": "No data to display.",
  "TEXT_ENDS_WITH": "Ends With",
  "TEXT_EQUALS": "Equals",
  "TEXT_EQUAL_TO": "Equal to",
  "TEXT_EXPAND_ALL_GROUPS": "Extend all groups",
  "TEXT_EXPORT_TO_CSV": "Export in CSV format",
  "TEXT_EXPORT_TO_EXCEL": "Export to Excel",
  "TEXT_EXPORT_TO_PDF": "Export to PDF",
  "TEXT_EXPORT_TO_TAB_DELIMITED": "Export in Text format (Tab delimited)",
  "TEXT_EXPORT_TO_TEXT_FORMAT": "Export in Text format",
  "TEXT_FILTER_SHORTCUTS": "Filter Shortcuts",
  "TEXT_FORCE_FIT_COLUMNS": "Force fit columns",
  "TEXT_FREEZE_COLUMNS": "Freeze Columns",
  "TEXT_GREATER_THAN": "Greater than",
  "TEXT_GREATER_THAN_OR_EQUAL_TO": "Greater than or equal to",
  "TEXT_GROUP_BY": "Group By",
  "TEXT_HIDE_COLUMN": "Hide Column",
  "TEXT_LESS_THAN": "Less than",
  "TEXT_LESS_THAN_OR_EQUAL_TO": "Less than or equal to",
  "TEXT_LOADING": "Loading...",
  "TEXT_NO_ELEMENTS_FOUND": "No elements found",
  "TEXT_NOT_CONTAINS": "Not contains",
  "TEXT_NOT_EQUAL_TO": "Not equal to",
  "TEXT_OK": "OK",
  "TEXT_OPTIONS": "Options",
  "TEXT_REMOVE_FILTER": "Remove Filter",
  "TEXT_REMOVE_SORT": "Remove Sort",
  "TEXT_SAVE": "Save",
  "TEXT_SELECT_ALL": "Select All",
  "TEXT_SORT_ASCENDING": "Sort Ascending",
  "TEXT_SORT_DESCENDING": "Sort Descending",
  "TEXT_STARTS_WITH": "Starts With",
  "TEXT_X_OF_Y_SELECTED": "# of % selected",
  "TEXT_BLANK_VALUES": "Blank Values",
  "TEXT_NON_BLANK_VALUES": "Non-Blank Values",
  "TEXT_FUTURE": "Future",
  "TEXT_ITEMS": "items",
  "TEXT_ITEMS_PER_PAGE": "items per page",
  "TEXT_ITEMS_SELECTED": "items selected",
  "TEXT_LAST_UPDATE": "Last Update",
  "TEXT_NEXT_20_DAYS": "Next 20 days",
  "TEXT_OF": "of",
  "TEXT_PAGE": "Page",
  "TEXT_PAST": "Past",
  "TEXT_REFRESH_DATASET": "Refresh Dataset",
  "TEXT_SYNCHRONOUS_RESIZE": "Synchronous resize",
  "TEXT_TODAY": "Today",
  "TEXT_TOGGLE_FILTER_ROW": "Toggle Filter Row",
  "TEXT_TOGGLE_PRE_HEADER_ROW": "Toggle Pre-Header Row",
  "TEXT_TECHNICAL_NAMES_REPORT": "View Technical Names",
  "TEXT_RESIZE_ALL_BY_CONTENT": "Resize All By Content"
}
